import { render, staticRenderFns } from "./StandardBtnsTemplate.vue?vue&type=template&id=576d9d3a&scoped=true"
import script from "./StandardBtnsTemplate.vue?vue&type=script&lang=js"
export * from "./StandardBtnsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576d9d3a",
  null
  
)

export default component.exports